import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { breadcrumbList } from "@/lib/schema";
import { IndustriesContent } from "@/components/IndustriesContent";

const TITLE = "ISO Certification by Industry in Iraq | IraqCert";
const DESC =
  "IraqCert delivers ISO certification across oil and gas, construction, government, and manufacturing, helping Iraqi firms win tenders and qualify for major contracts.";

export const Route = createFileRoute("/industries/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: absolute("/industries") },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/industries") }, ...hreflangLinks("/industries")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbList([
            { name: "Home", path: "/" },
            { name: "Industries", path: "/industries" },
          ]),
        ),
      },
    ],
  }),
  component: IndustriesContent,
});
